var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklistEndApproveAll = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 150,
  height: 151,
  viewBox: "0 0 150 151",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75 137.26C105.243 137.26 129.76 134.52 129.76 131.14C129.76 127.76 105.243 125.02 75 125.02C44.7569 125.02 20.24 127.76 20.24 131.14C20.24 134.52 44.7569 137.26 75 137.26Z",
  fill: "#E2E2E2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.13,
  d: "M135.6 13.2354H14.3999C11.0862 13.2354 8.3999 15.9216 8.3999 19.2354V92.9154C8.3999 96.2291 11.0862 98.9154 14.3999 98.9154H135.6C138.914 98.9154 141.6 96.2291 141.6 92.9154V19.2354C141.6 15.9216 138.914 13.2354 135.6 13.2354Z",
  fill: "#82EA5B"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M135.615 13.5049H14.1748C10.9936 13.5049 8.41479 16.0837 8.41479 19.2649V92.1549C8.41479 95.336 10.9936 97.9149 14.1748 97.9149H135.615C138.796 97.9149 141.375 95.336 141.375 92.1549V19.2649C141.375 16.0837 138.796 13.5049 135.615 13.5049Z",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 83.8447H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 69.7744H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 55.71H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 41.6396H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 27.5703H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.215 13.5049V97.9149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0547 13.5049V97.9149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8948 13.5049V97.9149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.7349 13.5049V97.9149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.5747 13.5049V97.9149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_31451_21046",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 119,
  y: 111,
  width: 2,
  height: 5
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M119.42 111.011L120.97 115.631L120.995 115.606L119.42 111.011Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_31451_21046)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.995 111.011H119.42V115.631H120.995V111.011Z",
  fill: "#EE8322"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M119.395 110.926H119.39L119.42 111.011L119.395 110.926Z",
  fill: "#DE4305"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9649 111.365L43.4849 115.695L43.4999 115.715L44.9649 111.365Z",
  fill: "#EE8322"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M122.175 118.396L124.11 121.916C124.435 122.451 124.345 123.136 123.9 123.571L119.395 127.976C119.105 128.261 118.715 128.416 118.315 128.416H112.75C111.86 128.416 111.13 127.761 111.01 126.886C110.875 125.886 111.65 125.436 112.445 125.111C113.195 124.801 113.84 124.271 114.425 123.706C115.4 122.766 116.265 121.686 117.035 120.566L117.075 120.506",
  fill: "#727D79"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M94.9599 120.721L93.0199 128.486H81.2099C78.9999 128.486 78.4299 125.396 80.5049 124.636C80.5349 124.626 80.5649 124.616 80.5949 124.606C83.5699 123.571 87.1099 121.456 87.1099 121.456",
  fill: "#727D79"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_31451_21046",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 105,
  y: 75,
  width: 18,
  height: 47
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M122.86 75.8154L114.705 97.3004L122.08 118.395L115.87 121.76L106 100.52C105.3 99.0104 105.14 97.3004 105.56 95.6904L107.85 86.8154L122.86 75.8154Z",
  fill: "white"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_31451_21046)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122.86 75.8154L114.705 97.3004L122.08 118.395L115.87 121.76L106 100.52C105.3 99.0104 105.14 97.3004 105.56 95.6904L107.85 86.8154",
  fill: "#D7D8D6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.99 76.46L105.52 103.51L103.84 91.86",
  fill: "#ACACAC"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M122.905 72.71C122.905 72.71 124.115 78.53 119.8 82.09L115.485 85.65L104.885 93.85C103.365 95.025 102.25 96.65 101.705 98.495L94.9549 121.285L87.1099 121.455C87.1099 121.455 90.9799 92.38 92.0149 91.17C93.0499 89.96 106.405 71.155 105.64 72.705H122.905",
  fill: "#D7D8D6"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M88.355 66.4852L96.03 64.9202L94.735 58.5802L88.815 59.7902L82.595 48.8252L78.75 50.5552L83.835 63.9952C84.525 65.8202 86.44 66.8752 88.35 66.4852",
  fill: "#C1813E"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3649 65.9102L93.2249 58.1302L102.055 54.5252C104.87 53.3852 107.93 55.4802 107.895 58.5152C107.875 60.2702 105.93 62.1602 104.285 62.7702L96.3649 65.9102Z",
  fill: "#006C43"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M103.14 54.2402C102.78 54.2852 102.415 54.3752 102.055 54.5252L93.2249 58.1302L96.3649 65.9102L101.295 63.9552L100.565 61.4252C100.35 60.7802 100.245 60.1202 100.245 59.4752C100.245 57.3752 101.34 55.3902 103.16 54.2752L103.14 54.2402Z",
  fill: "url(#paint0_linear_31451_21046)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M110.47 53.2456L104.105 55.9606L101.43 51.1956L99.765 51.1556C98.455 51.0156 98.65 49.5456 98.705 48.6206C98.745 47.9006 98.79 47.1756 98.83 46.4556C98.56 46.4956 98.22 46.5006 98.095 46.2606C98.015 46.1056 98.065 45.9206 98.115 45.7556C98.47 44.6006 98.825 43.4456 99.335 42.3556C99.875 41.1956 100.585 39.5356 102.01 39.4806C103.67 39.4156 105.24 40.1556 106.72 40.9056C108.11 41.6106 108.735 42.9606 108.83 44.4956C108.875 45.2106 108.775 45.9356 108.535 46.6106C108.47 46.7956 107.48 48.4556 107.45 48.4106L110.475 53.2506",
  fill: "#C1813E"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M101 44.54C101 44.7 100.87 44.83 100.71 44.83C100.55 44.83 100.42 44.7 100.42 44.54C100.42 44.38 100.55 44.25 100.71 44.25C100.87 44.25 101 44.38 101 44.54Z",
  fill: "#0E1010"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5598 47.4205C100.085 47.4955 100.58 47.2355 100.85 46.7855C100.96 46.6055 100.68 46.4455 100.57 46.6205C100.425 46.8605 100.22 47.0205 99.9498 47.0805C99.8748 47.0955 99.7998 47.1055 99.7198 47.1055C99.6948 47.1055 99.5598 47.0905 99.6448 47.1055C99.4398 47.0755 99.3548 47.3855 99.5598 47.4155V47.4205Z",
  fill: "#8B5624"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M103.9 44.2908C103.785 43.6558 103.5 43.1658 102.66 42.9258C102 42.7358 101.3 42.7408 100.63 42.5758C100.17 42.4608 99.73 42.2708 99.335 42.0058C99.01 41.7908 98.715 41.5258 98.49 41.2058C97.87 40.3208 97.9 39.0458 98.54 38.1758C99.175 37.3058 100.15 36.8708 101.18 37.1808C102.265 37.5108 103.065 38.4008 103.995 39.0508C104.78 39.6008 105.68 39.9908 106.62 40.1808C107.51 40.3608 108.47 40.3858 109.23 40.8808C109.635 41.1458 109.955 41.5258 110.205 41.9408C110.975 43.2158 111.125 44.8108 110.8 46.2658C110.475 47.7408 109.62 49.7558 107.815 49.7358C107.03 49.7258 106.27 49.2658 105.9 48.5758C106.39 48.3308 106.9 48.0708 107.205 47.6158C107.46 47.2308 107.535 46.7458 107.475 46.2858C107.43 45.9508 107.31 45.6208 107.09 45.3608C106.795 45.0108 106.325 44.8208 105.875 44.8558C105.42 44.8958 104.99 45.1658 104.76 45.5608C104.695 45.6708 104.635 45.8008 104.515 45.8558C104.365 45.9208 104.185 45.8308 104.095 45.6958C104.005 45.5608 103.99 45.3858 103.985 45.2258C103.965 44.8958 103.95 44.5808 103.9 44.2958V44.2908Z",
  fill: "#0E1010"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M113.14 50.5557L104.29 53.7357C101.165 54.8607 99.5099 58.2757 100.565 61.4257L104.26 74.2657H122.605L113.14 50.5607",
  fill: "#006C43"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M111.335 51.2057L109.59 51.8307L104.29 53.7357C103.89 53.8807 103.51 54.0607 103.16 54.2757C101.34 55.3907 100.245 57.3757 100.245 59.4757C100.245 60.1207 100.345 60.7807 100.565 61.4257L104.26 74.2657H115.725L117.23 72.1157L113.95 64.1507L112.915 64.5957L109.66 56.3857C109.445 55.8557 109.345 55.3207 109.345 54.7957C109.345 53.3307 110.115 51.9707 111.33 51.2057M113.14 50.5557L113.045 50.5907C113.08 50.5907 113.115 50.5807 113.15 50.5807L113.14 50.5557Z",
  fill: "url(#paint1_linear_31451_21046)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M113.7 84.9301L122.62 75.4701C123.885 74.1301 124.245 72.1701 123.545 70.4651L115.62 51.2051L109.645 53.6651L117.235 72.1101L110.27 82.0501L113.705 84.9251",
  fill: "#C1813E"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M120.705 61.2301L112.92 64.5951L109.665 56.3851C108.53 53.5751 110.62 50.5151 113.65 50.5551C115.405 50.5751 116.96 51.6751 117.575 53.3201L120.71 61.2301",
  fill: "#006C43"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M113.595 50.5558C113.445 50.5558 113.295 50.5658 113.15 50.5758C113.115 50.5758 113.08 50.5858 113.045 50.5858C110.895 50.8608 109.35 52.7208 109.35 54.7908C109.35 55.3158 109.45 55.8508 109.665 56.3808L112.92 64.5908L120.705 61.2258L117.57 53.3158C116.96 51.6708 115.4 50.5758 113.645 50.5508C113.645 50.5508 113.61 50.5508 113.59 50.5508",
  fill: "url(#paint2_linear_31451_21046)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M110.825 81.6357C109.825 81.8457 107.76 82.4957 106.805 82.9657C106.505 83.1157 106.215 83.2657 105.91 83.3957C105.73 83.4757 105.34 83.5307 105.215 83.6857C104.72 84.3057 105.96 84.2707 106.29 84.2757C106.825 84.2907 107.82 84.2957 107.625 85.0657C107.395 85.9657 106.52 86.3907 105.77 86.7957C105.23 87.0857 103.675 87.9057 104.04 88.7307C104.265 89.2357 105.335 89.4607 105.805 89.5807C108.71 90.3457 110.95 88.1407 112.62 86.0757C112.995 85.6107 113.395 85.1857 113.73 84.6957",
  fill: "#C1813E"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M104.025 51.1953H101.43L102.295 52.7353L104.025 51.1953Z",
  fill: "#92410F"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5999 48.825C82.5999 48.825 78.9799 39.505 78.7549 39.55C78.5299 39.595 78.3699 39.795 78.3099 40.01C78.2499 40.225 78.2699 40.46 78.2949 40.68C78.5199 42.75 79.1849 44.715 79.1999 46.81C78.8699 46.195 78.51 45.595 78.125 45.015C78.06 44.915 77.98 44.81 77.87 44.78C77.705 44.735 77.5349 44.865 77.4749 45.02C77.4149 45.18 77.4349 45.355 77.4599 45.52C77.5949 46.485 77.78 47.44 78.01 48.39C78.225 49.295 78.5349 50.35 78.9349 51.18",
  fill: "#C1813E"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6199 53.9099H52.1599L52.2199 53.8799L52.1349 51.4049L53.7449 51.3649C55.0099 51.2299 54.8249 49.8099 54.7699 48.9149C54.7299 48.2199 54.6899 47.5199 54.6499 46.8249C54.9099 46.8599 55.2399 46.8649 55.3599 46.6349C55.4399 46.4849 55.3899 46.3049 55.3399 46.1449C54.9999 45.0299 54.6549 43.9149 54.1599 42.8599C53.6649 41.8049 53.0149 40.8049 52.1349 40.0449C51.4199 39.4249 50.5399 39.6299 49.6099 39.8149C48.6799 39.9949 47.8199 40.4549 47.0749 41.0449C46.5749 41.4399 46.1199 41.8999 45.7849 42.4399C44.5449 44.4349 44.7449 46.9899 46.3249 48.7099L44.6249 53.9049",
  fill: "#EBB990"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M53.08 45.4999C53.2402 45.4999 53.37 45.3701 53.37 45.2099C53.37 45.0498 53.2402 44.9199 53.08 44.9199C52.9199 44.9199 52.79 45.0498 52.79 45.2099C52.79 45.3701 52.9199 45.4999 53.08 45.4999Z",
  fill: "#0E1010"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M54.145 47.7806C54.23 47.7706 54.105 47.7806 54.08 47.7806C54 47.7806 53.92 47.7756 53.84 47.7556C53.57 47.6956 53.365 47.5306 53.22 47.2956C53.11 47.1156 52.835 47.2806 52.94 47.4606C53.21 47.9056 53.71 48.1706 54.23 48.0956C54.435 48.0656 54.35 47.7556 54.145 47.7856V47.7806Z",
  fill: "#8B5624"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask2_31451_21046",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 41,
  y: 76,
  width: 18,
  height: 47
}, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M41.235 76.9355L49.39 98.4205L42.015 119.516L48.225 122.881L58.095 101.641C58.795 100.131 58.955 98.4205 58.535 96.8105L56.245 87.9355L41.23 76.9355",
  fill: "white"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_31451_21046)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.2349 76.9355L49.3899 98.4205L42.3599 118.781L48.4799 122.326L58.0899 101.641C58.7899 100.131 58.9499 98.4205 58.5299 96.8105L56.2399 87.9355",
  fill: "#D7D8D6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.105 77.5859L58.58 104.631L60.26 92.9859",
  fill: "#ACACAC"
}))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M41.195 73.8301C41.195 73.8301 39.985 79.6501 44.3 83.2101L48.615 86.7701L60.045 95.6101C61.025 96.3701 61.735 97.4251 62.07 98.6201L68.075 120.245H75.885C75.885 120.245 73.125 93.5001 72.09 92.2901C71.055 91.0801 57.7 72.2751 58.465 73.8251H41.2",
  fill: "#D7D8D6"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M68.25 66.4852L60 64.3752L61.96 58.1602L67.795 59.7902L74.015 48.8252L77.86 50.5552L72.775 63.9952C72.085 65.8202 70.17 66.8752 68.26 66.4852",
  fill: "#EBB990"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M60.24 65.9102L63.38 58.1302L54.55 54.5252C51.735 53.3852 48.675 55.4802 48.71 58.5152C48.73 60.2702 50.675 62.1602 52.32 62.7702L60.24 65.9102Z",
  fill: "#00D38D"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8149 54.2949C54.5299 54.7599 55.1449 55.3799 55.6099 56.1249C55.6099 56.1249 59.0749 60.6699 59.0699 62.9299C59.0699 63.0749 59.0549 63.2099 59.0249 63.3349C58.8599 64.0099 58.3949 64.6349 57.7699 64.9249L60.2399 65.9049L63.3799 58.1249L54.5499 54.5199C54.3049 54.4199 54.0599 54.3449 53.8149 54.2949Z",
  fill: "url(#paint3_linear_31451_21046)"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M73.925 48.905C73.925 48.905 77.545 39.585 77.77 39.63C77.995 39.675 78.155 39.875 78.215 40.09C78.275 40.305 78.255 40.54 78.23 40.76C78.005 42.83 77.34 44.795 77.325 46.89C77.655 46.275 78.015 45.675 78.4 45.095C78.465 44.995 78.545 44.89 78.655 44.86C78.82 44.815 78.99 44.945 79.05 45.1C79.11 45.26 79.09 45.435 79.065 45.6C78.93 46.565 78.745 47.52 78.515 48.47C78.295 49.375 77.99 50.43 77.59 51.26",
  fill: "#EBB990"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M50.835 53.3502C52.79 53.4252 54.575 54.4652 55.61 56.1252C55.61 56.1252 59.535 61.2752 59.025 63.3402C58.83 64.1252 58.245 64.8352 57.46 65.0402L59.3 74.8002H41.24L39.91 59.4152C39.18 56.1002 41.78 52.9952 45.17 53.1302L50.84 53.3552",
  fill: "#00D38D"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0401 56.6801C39.9151 57.0601 39.83 57.4601 39.8 57.8701L40.0401 56.6801ZM44.9551 53.1201C44.7901 53.1201 44.625 53.1301 44.465 53.1451C46.455 53.3601 48.0201 55.0701 48.0201 57.1051C48.0201 57.3801 47.9901 57.6551 47.93 57.9401L46.53 64.6001L45.5201 64.5551L43.5251 73.7601L44.57 74.8001H59.295L58.78 72.0701L57.4551 65.0451C58.2351 64.8401 58.8251 64.1301 59.0201 63.3451C59.0501 63.2201 59.065 63.0851 59.065 62.9401C59.065 60.6751 55.605 56.1351 55.605 56.1351C54.57 54.4751 52.7851 53.4351 50.8301 53.3601L45.16 53.1351C45.09 53.1351 45.0201 53.1351 44.9501 53.1351",
  fill: "url(#paint4_linear_31451_21046)"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M48.9199 85.0451L39.0899 77.7601C37.6949 76.7251 37.0349 74.9751 37.4049 73.2751L41.5549 54.1201L47.4999 55.4101L43.5249 73.7551L51.6249 81.8101L48.9199 85.0451Z",
  fill: "#EBB990"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M38.505 64.2503L46.53 64.5953L47.93 57.9353C48.515 55.1453 46.075 52.6553 43.27 53.1953C41.65 53.5053 40.39 54.7803 40.095 56.4053L38.5 64.2503",
  fill: "#00D38D"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0399 53.1202C43.7899 53.1202 43.5299 53.1452 43.2749 53.1952C41.6549 53.5052 40.3949 54.7802 40.0999 56.4052L38.5049 64.2502L46.5299 64.5952L47.9299 57.9352C47.9899 57.6552 48.0199 57.3752 48.0199 57.1002C48.0199 55.0652 46.4549 53.3552 44.4649 53.1402C44.3249 53.1252 44.1849 53.1152 44.0399 53.1152",
  fill: "url(#paint5_linear_31451_21046)"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M50.71 81.4951C51.67 81.5251 53.615 81.9451 54.58 82.2251C54.88 82.3101 55.18 82.4051 55.48 82.4751C55.66 82.5201 56.03 82.5051 56.17 82.6301C56.73 83.1201 55.58 83.2951 55.275 83.3551C54.78 83.4551 53.865 83.6301 54.17 84.3101C54.53 85.1051 55.41 85.3551 56.175 85.6051C56.72 85.7851 58.3 86.2851 58.1 87.1101C57.975 87.6151 57.02 88.0001 56.605 88.1901C54.045 89.3801 51.605 87.7101 49.715 86.0751C49.29 85.7101 48.85 84.6851 48.46 84.2901",
  fill: "#EBB990"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M68.0499 120.075L75.5549 119.73C77.2099 122.26 79.2549 125.19 82.3899 125.94C82.8999 126.06 83.4299 126.12 83.9049 126.335C84.3849 126.545 84.8199 126.955 84.8749 127.475C84.9299 127.995 84.4499 128.56 83.9399 128.44H75.3049L73.0349 125.945L72.7549 128.445H70.1999L68.0449 120.08L68.0499 120.075Z",
  fill: "#3E4E48"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M48.23 121.975C48.02 123.655 48.815 125.3 50.265 126.175L51.4151 126.87C52.1401 127.31 51.825 128.425 50.975 128.415L44.6101 128.355L42.8 126.545L42.715 123.61L41.5951 125.595L40.3 124.73L42.37 118.775",
  fill: "#3E4E48"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M52.1298 51.4053H49.8098L52.1798 52.9403L52.1298 51.4053Z",
  fill: "#D98651"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9399 58.7958C25.5299 57.5108 25.6249 56.0708 26.3699 54.9558C27.0599 53.9258 28.2299 52.9808 29.3999 52.5758C30.6249 52.1508 31.9999 52.0858 33.0799 51.3108C34.2349 50.4808 34.7499 49.0308 35.6499 47.9258C36.3249 47.0958 37.2299 46.4558 38.2399 46.1008C39.8049 45.5458 41.6399 45.6408 42.9499 44.6208C44.0699 43.7508 44.5199 42.2908 45.3849 41.1708C46.2749 40.0208 47.4199 39.3558 48.8349 39.0358C50.0449 38.7608 51.6599 39.1508 52.6249 39.9608C53.7399 40.8958 52.5649 42.1158 51.6499 42.5608C50.8849 42.9308 50.0249 43.0508 49.1799 43.1658L49.3649 46.3908C48.8449 45.9558 48.0299 45.6708 47.4449 46.0108C47.1149 46.2058 46.9049 46.5658 46.8149 46.9358C46.5799 47.8958 47.1149 48.9808 48.0149 49.3858C48.0999 50.5008 47.4699 51.7158 46.5749 52.3758C46.1549 52.6858 45.6649 52.8958 45.2799 53.2458C44.7849 53.7008 44.5149 54.3458 44.0749 54.8508C42.1349 57.0658 38.2199 56.2958 36.2849 58.6308C35.8549 59.1458 35.5849 59.7758 35.1999 60.3208C34.2549 61.6658 32.6199 62.4858 30.9749 62.4708C29.3349 62.4558 27.7249 61.6258 26.7299 60.3208C26.3849 59.8658 26.1149 59.3458 25.9449 58.7958H25.9399Z",
  fill: "#8B5624"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M71.1099 42.6304L74.1299 42.1904",
  stroke: "#EF6AEF",
  strokeWidth: 5,
  strokeMiterlimit: 10
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M72.05 36.54L74.86 37.735",
  stroke: "#DF1CF4",
  strokeWidth: 5,
  strokeMiterlimit: 10
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M87.06 42.6304L84.04 42.1904",
  stroke: "#EF6AEF",
  strokeWidth: 5,
  strokeMiterlimit: 10
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1198 36.54L83.3098 37.735",
  stroke: "#DF1CF4",
  strokeWidth: 5,
  strokeMiterlimit: 10
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3899 31.7354L78.7799 34.7603",
  stroke: "#EF6AEF",
  strokeWidth: 5,
  strokeMiterlimit: 10
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_31451_21046",
  x1: 108.871,
  y1: 60.2616,
  x2: 94.1365,
  y2: 60.2616,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_31451_21046",
  x1: 121.986,
  y1: 62.5152,
  x2: 99.9589,
  y2: 62.5152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_31451_21046",
  x1: 122.077,
  y1: 57.677,
  x2: 110.888,
  y2: 57.677,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_31451_21046",
  x1: 64.2499,
  y1: 60.2613,
  x2: 49.5157,
  y2: 60.2613,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_31451_21046",
  x1: 41.5477,
  y1: 73.8703,
  x2: 58.2521,
  y2: 57.1659,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_31451_21046",
  x1: 47.8567,
  y1: 58.8234,
  x2: 38.2991,
  y2: 58.8234,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklistEndApproveAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist-end-approve-all.cd60cd5c249ad4c63fd3e1ad7b344208.svg";